import { TeeMeasureLabel } from '../../types/databaseTables/idealteemeasures';
import { GarmentObject } from '../../types/reducers/filterReducer';

export function colorDifference(value: number | string): string {
    if (typeof value !== 'number') return 'grey';
    if (value === 0) return 'darkgreen';
    if (Math.abs(value) <= 1) return 'darkgreen';
    if (Math.abs(value) <= 2) return 'darkorange';
    if (Math.abs(value) > 2) return 'darkred';
    return "grey";
}

// eslint-disable-next-line @typescript-eslint/ban-types, @typescript-eslint/no-explicit-any
function hasKey<K extends string>(k: K, x: any): x is Record<K, {}> {
    return k in x;
}

// This is to deal with the fact that the imageurls went from a string[] to a Record<string,strin[]>. I think I corrected everything to the Record type so this is possible unnecessary...
export function getImageUrlFromGarmentObject(garmentTypeObjectWithImageUrls: GarmentObject, selectedColor: string): string {
    const { imageurls } = garmentTypeObjectWithImageUrls
    // If there are no images, return default image
    if (garmentTypeObjectWithImageUrls == null || imageurls == null || (imageurls as unknown as string[]).length < 1 || Object.keys(imageurls).length < 1) return '/img/tshirt.svg';
    // If there are an array of images, return the first image
    if (Array.isArray(imageurls) && imageurls.length > 0) return imageurls[0];
    // If the imageurls is an object and the key exists, return the first element of that array
    if (hasKey(selectedColor, imageurls) && selectedColor in imageurls && imageurls[selectedColor as keyof typeof imageurls].length > 0) {
        return imageurls[selectedColor][0];
    }
    // If all above fails, and we have 'nocolor', then use that first item
    if ('nocolor' in imageurls && imageurls.nocolor.length > 0) return imageurls.nocolor[0];
    // Return default image if none of the above work
    return '/img/tshirt.svg'
}

export const teeLabelsArray: TeeMeasureLabel[] = ['chest', 'shouldertoshoulder', 'frontlength', 'waist', 'hem', 'sleeveopening', 'sleevelength']
export const names = { 'chest': 'Chest', 'shouldertoshoulder': 'Shoulder to Shoulder', 'frontlength': 'Front Length', 'waist': 'Waist', 'hem': 'Hem', 'sleeveopening': 'Sleeve Opening', 'sleevelength': 'Sleeve Length' }